/**
 * SEO: FAQ для JSON-LD (FAQPage) — тексты из landingFaq.js.
 */
import { PRICE_FROM_FALLBACK } from '@/lib/siteCopy';
import { buildLandingFaqItems, faqAnswerPlainText } from '@/lib/landingFaq';

const faqItems = buildLandingFaqItems({ priceLabel: PRICE_FROM_FALLBACK });

/** Массив Question для свойства mainEntity у schema.org/FAQPage */
export const LANDING_FAQ_MAIN_ENTITY = faqItems.map((item) => ({
  '@type': 'Question',
  name: item.question,
  acceptedAnswer: {
    '@type': 'Answer',
    text: faqAnswerPlainText(item.answer),
  },
}));
